import { Auth } from 'aws-amplify'

export default async (userName, password) => {
  return Auth.signIn(userName, password)
}
